var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikesFunnel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.822 23.8a.782.782 0 0 1-.718-.483c-.663-1.567-1.996-2.69-3.286-3.778C7.941 17.957 6 16.322 6 13.336 6 9.014 9.266 7 11.474 7c1.582 0 2.89.546 3.926 1.258C15.81 7.974 17.317 7 18.757 7 21.283 7 24 8.752 24 12.6c0 7.588-9.518 11.015-9.923 11.157a.787.787 0 0 1-.255.043Z",
    fill: "#6667AB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#F47444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.87 6.869h1.107l.106-4.21h-1.318l.105 4.21Zm.554 2.184c.4 0 .716-.303.716-.69 0-.387-.316-.69-.716-.69-.4 0-.716.303-.716.69 0 .387.316.69.716.69Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikesFunnel);
export default __webpack_public_path__ + "static/media/likes-funnel.200a89a5d3bf74eb97428f5294a35844.svg";
export { ForwardRef as ReactComponent };